import { render, staticRenderFns } from "./SimplifiedQuantitySelection.vue?vue&type=template&id=478294ce&scoped=true"
import script from "./SimplifiedQuantitySelection.vue?vue&type=script&lang=js"
export * from "./SimplifiedQuantitySelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478294ce",
  null
  
)

export default component.exports